var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildingIconLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "18px",
    viewBox: "0 0 17 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Building Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.00048 12 0.00048 12 16.00048 0 16.00048"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 -0.27952 16 -0.27952 16 1.72048 0 1.72048"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home---Multiple",
    transform: "translate(-29.000000, -193.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Side-Bar",
    transform: "translate(0.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Building-Icon",
    transform: "translate(29.000000, 103.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(2.000000, -0.000480)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4675768,16.00048 L0.532423208,16.00048 C0.238313256,16.00048 0,15.7820219 0,15.5127078 L0,0.488382929 C0,0.218938144 0.238313256,0.00048 0.532423208,0.00048 L11.4675768,0.00048 C11.7618294,0.00048 12,0.218938144 12,0.488382929 L12,15.5127078 C12,15.7820219 11.7618294,16.00048 11.4675768,16.00048",
    id: "Fill-1",
    fill: "#3E586B",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(0.000000, 15.279520)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7818305,1.72048 L0.218305085,1.72048 C0.0977627119,1.72048 0,1.60955692 0,1.47294154 L0,-0.0319815385 C0,-0.168596923 0.0977627119,-0.27952 0.218305085,-0.27952 L15.7818305,-0.27952 C15.9023729,-0.27952 16,-0.168596923 16,-0.0319815385 L16,1.47294154 C16,1.60955692 15.9023729,1.72048 15.7818305,1.72048",
    id: "Fill-16",
    fill: "#37596D",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.069024,5.010844 L5.050504,5.010844 C5.035264,5.010844 5.022784,4.998364 5.022784,4.983244 L5.022784,2.964604 C5.022784,2.949364 5.035264,2.937004 5.050504,2.937004 L7.069024,2.937004 C7.084264,2.937004 7.096624,2.949364 7.096624,2.964604 L7.096624,4.983244 C7.096624,4.998364 7.084264,5.010844 7.069024,5.010844",
    id: "Fill-4",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.870708,5.010844 L8.852068,5.010844 C8.836828,5.010844 8.824468,4.998364 8.824468,4.983244 L8.824468,2.964604 C8.824468,2.949364 8.836828,2.937004 8.852068,2.937004 L10.870708,2.937004 C10.885948,2.937004 10.898188,2.949364 10.898188,2.964604 L10.898188,4.983244 C10.898188,4.998364 10.885948,5.010844 10.870708,5.010844",
    id: "Fill-6",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.069024,9.287608 L5.050504,9.287608 C5.035264,9.287608 5.022784,9.275248 5.022784,9.260008 L5.022784,7.241368 C5.022784,7.226128 5.035264,7.213768 5.050504,7.213768 L7.069024,7.213768 C7.084264,7.213768 7.096624,7.226128 7.096624,7.241368 L7.096624,9.260008 C7.096624,9.275248 7.084264,9.287608 7.069024,9.287608",
    id: "Fill-8",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.870708,9.287608 L8.852068,9.287608 C8.836828,9.287608 8.824468,9.275248 8.824468,9.260008 L8.824468,7.241368 C8.824468,7.226128 8.836828,7.213768 8.852068,7.213768 L10.870708,7.213768 C10.885948,7.213768 10.898188,7.226128 10.898188,7.241368 L10.898188,9.260008 C10.898188,9.275248 10.885948,9.287608 10.870708,9.287608",
    id: "Fill-10",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.069024,13.722796 L5.050504,13.722796 C5.035264,13.722796 5.022784,13.710436 5.022784,13.695196 L5.022784,11.676556 C5.022784,11.661316 5.035264,11.648956 5.050504,11.648956 L7.069024,11.648956 C7.084264,11.648956 7.096624,11.661316 7.096624,11.676556 L7.096624,13.695196 C7.096624,13.710436 7.084264,13.722796 7.069024,13.722796",
    id: "Fill-12",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.870708,13.722796 L8.852068,13.722796 C8.836828,13.722796 8.824468,13.710436 8.824468,13.695196 L8.824468,11.676556 C8.824468,11.661316 8.836828,11.648956 8.852068,11.648956 L10.870708,11.648956 C10.885948,11.648956 10.898188,11.661316 10.898188,11.676556 L10.898188,13.695196 C10.898188,13.710436 10.885948,13.722796 10.870708,13.722796",
    id: "Fill-14",
    fill: "#FFFFFF"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingIconLight);
export default __webpack_public_path__ + "static/media/building-icon-light.9acc2a0a7eff05726b03ed5528e24285.svg";
export { ForwardRef as ReactComponent };